import hljs from 'highlight.js';

export function copySnippetCode(eventTarget) {
    let target = $(eventTarget)
    const buttonParent = target.parents("div.copy-container");
    let code = buttonParent.prev();
    let codeText = code.text();

    const codeCopied = buttonParent.next();
    codeCopied.removeClass('no-display');

    navigator.clipboard.writeText(codeText);

    setTimeout(() => {
        codeCopied.addClass('no-display');
    }, 2000)
}

export function highlightCodeBlock() {
    $("pre.dp-code-block").each(function () {
        if (!this.classList.contains("hljs")) {
            hljs.highlightElement(this);
            let codeToCopy = this.innerText;
            $(this).prepend(`<a class="dp-code-block-copy" role="button"><span class="material-icons md-18">content_copy</span></a>`);
            $(this)
                .children(".dp-code-block-copy")
                .click(function (event) {
                    event.preventDefault();
                    navigator.clipboard.writeText(codeToCopy);
                    let icon = $(this).children().first();
                    icon.text("done");
                    setTimeout(function () {
                        icon.text("content_copy");
                    }, 1500);
                });
        }
    });
}